import { RouteConfig } from 'vue-router';

const PatientList = () => import(/* webpackChunkName: "Edr" */  './views/patient-list/patient-list.vue');
const PatientDetail = () => import(/* webpackChunkName: "Edr" */  './views/patient-detail/patient-detail.vue');
const DataExport = () => import(/* webpackChunkName: "Edr" */  './views/data-export/data-export.vue');
const MobanList = () => import(/* webpackChunkName: "Edr" */  './views/moban-guanli/moban-list.vue');



const routers: RouteConfig[] = [
    {
        path: 'patient-list',
        component: PatientList,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "patient-detail",
        component: PatientDetail,
    },
    {
        path: "data-export",
        component: DataExport
    },
    {
        path: "moban-list",
        component: MobanList
    }
];

export default routers;
